import React from 'react';
import { useSecurity } from '../../../helpers/SecurityHooks';
import { appendScriptsCallback } from '../../../helpers/Utils';

export function TradingForecastAuditTrailRevenueCustomPage(): React.ReactElement {
  const currentSecurity = useSecurity('Trading', 'ForecastAuditTrail');
  React.useEffect(() => {
    if (currentSecurity.checkAccess()) {
      appendScriptsCallback(["Areas/Trading/Scripts/Resources/en/res.ForecastAuditTrail.en.js",
        "Areas/Trading/Scripts/Resources/en/res.AgencyProfilePeriod.en.js",
        "Areas/Trading/Scripts/Resources/en/res.ClientProfilePeriod.en.js",
        "Areas/Trading/Scripts/Resources/en/Types.en.js",
        "Areas/Trading/Scripts/Enums.js",
        'Areas/Trading/Scripts/jquery.shared.custom.js',
        "Areas/Trading/Scripts/ForecastAuditTrail/Index.custom.js"], "initTradingForecastAuditTrail", { area: 0 });
    }
  }, []);
  return (
    <div className="container-fluid">
      <header className="complete-grid">
        <div id="gridFilter1">
          <div id="gridfilter-toolbar"></div>
        </div>
      </header>
      <section id="gridContainer"></section>
      <ul id="gridContainer-menu"></ul>
    </div>
  );
}
export function TradingForecastAuditTrailDealCustomPage(): React.ReactElement {
  const currentSecurity = useSecurity('Trading', 'ForecastAuditTrail');
  React.useEffect(() => {
    if (currentSecurity.checkAccess()) {
      appendScriptsCallback(["Areas/Trading/Scripts/Resources/en/res.ForecastAuditTrail.en.js",
        "Areas/Trading/Scripts/Resources/en/res.AgencyProfilePeriod.en.js",
        "Areas/Trading/Scripts/Resources/en/res.ClientProfilePeriod.en.js",
        "Areas/Trading/Scripts/Resources/en/Types.en.js",
        "Areas/Trading/Scripts/Enums.js",
        'Areas/Trading/Scripts/jquery.shared.custom.js',
        "Areas/Trading/Scripts/ForecastAuditTrail/Index.custom.js"], "initTradingForecastAuditTrail", { area: 1 });
    }
  }, []);
  return (
    <div className="container-fluid">
      <header className="complete-grid">
        <div id="gridFilter1">
          <div id="gridfilter-toolbar"></div>
        </div>
      </header>
      <section id="gridContainer"></section>
      <ul id="gridContainer-menu"></ul>
    </div>
  );
}